/*
 * Campaigns — designated fundraising campaigns.
 *
 * HONESTY RULES (AGENTS.md):
 *  - raised/deployed are updated BY HAND from the books/Square records
 *  - never display figures the accounting cannot support
 *  - `raised` starts at what is ACTUALLY in hand (even $0)
 *
 * All money values in CENTS.
 */

const campaigns = [
  {
    id: "lamna-launch",
    active: true,
    icon: "🦈",
    name: "LAMNA Launch Fund",
    tagline: "Give our AI shark her own brain — and keep her swimming for the community.",
    goalCents: 160000, // $1,600 — itemized below, sums exactly
    raisedCents: 0, // staging placeholder — update from real records before promotion
    deployedCents: 0,
    budget: [
      { item: "Mac mini M4 (32GB) — LAMNA's AI server", amountCents: 139900 },
      { item: "Accessories & cables", amountCents: 14100 },
      { item: "12 months power & running costs", amountCents: 6000 },
    ],
    story:
      "LAMNA — our AI shark — never stops swimming. But right now, she's running on borrowed water. The LAMNA Launch Fund buys the computer brain she needs: a dedicated AI server that will power free, member-only tech help for every family in our community. When the fund completes, LAMNA goes live — for good.",
    perks:
      "Every donor who opts in gets their name on the LAMNA Credits page — permanently.",
    // ZelImpact outcomes: populated ONLY when the books support it.
    // milestones: label + done (verified by receipts). outcomeStory: published
    // after project completion. Leave null/undefined until real.
    milestones: null,
    outcomeStory: null,
  },
];

// consistency guard: budget must sum to goal
const budgetSum = campaigns.reduce(
  (sum, c) => sum + c.budget.reduce((s, b) => s + b.amountCents, 0),
  0
);
if (campaigns.some((c) => c.goalCents !== c.budget.reduce((s, b) => s + b.amountCents, 0))) {
  console.warn("[campaigns] budget items do not sum to goal — fix before deploying");
}

export default campaigns;
